// import { useComparisonStore } from '@/stores/comparisonStore';
// import MapService from '@/services/arcgis/MapServiceFacade';

/**
 * Component to sync comparison selection with map highlighting
 */
export function MapComparisonSync() {
  // const { selectedWards, isComparing } = useComparisonStore();

  // useEffect(() => {
  //   // Only highlight when in comparison mode
  //   if (isComparing && MapService.highlightMultipleWards) {
  //     const objectIds = selectedWards.map(ward => ward.objectid);
  //     MapService.highlightMultipleWards(objectIds);
  //   } else if (!isComparing && MapService.highlightMultipleWards) {
  //     // Clear multi-selection when not comparing
  //     MapService.highlightMultipleWards([]);
  //   }
  // }, [selectedWards, isComparing]);

  // This component doesn't render anything
  return null;
}
